import styled from 'styled-components';
import { Form } from 'antd';

export const StyledForm = styled(Form)`
  min-width: 245px;
  max-width: 245px;
  margin-bottom: 0;
  font-family: ${(props) => props.theme.fontText};

  .styled-category-selector {
    .user {
      .drop-down {
        margin-bottom: 20px;
      }
    }
  }

  .ant-select {
    display: flex;
    align-items: center;
  }

  .export-product-list-wrapper,
  .clear-filters-button-wrapper {
    margin-top: 16px;

    .ant-btn {
      width: 100%;
      height: 30px;
      background-color: transparent;
      border: 1px solid ${({ theme }) => theme.brand02};
      border-radius: 30px;
      font-size: 13px;
      font-weight: 400;
      color: ${({ theme }) => theme.colorText};
    }
  }

  .clear-filters-button-wrapper {
    .ant-btn {
      &:hover {
        border-color: ${({ theme }) => theme.brand02};
        color: ${({ theme }) => theme.brand02};
      }
    }
  }

  .qmark-filter-title {
    margin-bottom: 6px;
  }

  .wide-section {
    padding: 0;
    display: flex;
    flex-direction: column;
  }

  .category-sel-wrap {
    display: flex;
    flex-direction: column;

    .ant-form-item {
      margin-bottom: 0;
    }
  }

  .close-btn-wrapper {
    padding-bottom: 30px;

    .close-form-btn {
      width: 247px;
      height: 52px;
      background-color: ${({ theme }) => theme.white};
      border: 1px solid ${({ theme }) => theme.colorText};
      border-radius: 25px;
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme.colorText};
      cursor: pointer;
      z-index: 1002;
      transition: background-color 0.2s ease;

      &:hover {
        background-color: ${({ theme }) => theme.lightGrey};
      }
    }
  }

  .form-title {
    padding: 0 8px 8px 0;
    font-weight: 600;
    font-size: 16px;
  }

  .ant-select-selector {
    background-color: ${(props) => props.theme.lightGrey};
    min-width: 245px;
    min-height: 45px;
    border-radius: 5px;
    border: 1px solid ${(props) => props.theme.grey};
  }

  .qmark {
    flex-direction: column;
    gap: 5px;
  }

  :where(.ant-select).ant-select .ant-select-arrow {
    color: ${(props) => props.theme.stepArrowColor};
  }
`;
